import { ReactNode, useMemo } from 'react'
import { renderToRenderedPage } from '../document'
import { HTMLRenderedPage } from '../html-rendered-page'

export function Viewport({
  children,
  width,
  height
}: {
  children: ReactNode
  width: number
  height: number
}) {
  const page = useMemo(
    () => renderToRenderedPage(children, { width, height }),
    [children, width, height]
  )

  return <HTMLRenderedPage page={page} width={width} height={height} />
}
